// Global components for forrent plugin
import RegistrationForm from './RegistrationForm.vue'
import ContactForm from './ContactForm.vue'
import LoginForm from './LoginForm.vue'
import Navigation from './Navigation.vue'
import UserCategory from './UserCategory.vue'

export default {
  install(Vue) {
    Vue.component(ContactForm.name, ContactForm)
    Vue.component(LoginForm.name, LoginForm)
    Vue.component(Navigation.name, Navigation)
    Vue.component(RegistrationForm.name, RegistrationForm)
    Vue.component(UserCategory.name, UserCategory)
  }
}